import axios from 'axios'

const LfItemClaimService = {
  async getList (params = {}) {
    return axios.get('admin/lf-item-claims', { params })
  },

  async show (id) {
    return axios.get(`admin/lf-item-claims/${id}`)
  },

  async store (data) {
    return axios.post('admin/lf-item-claims', data)
  },

  async update (id, data) {
    return axios.put(`admin/lf-item-claims/${id}`, data)
  },

  async destroy (id) {
    return axios.delete(`admin/lf-item-claims/${id}`)
  }
}

export default LfItemClaimService
